import { memo, useState, useEffect } from 'react'

import { PickerStyleTag } from './Stylesheet/stylesheet'
import { Reactions } from './components/Reactions/Reactions'
import { Body } from './components/body/Body'
import { ElementRefContextProvider } from './components/context/ElementRefContext'
import { PickerConfigProvider } from './components/context/PickerConfigContext'
import { useReactionsModeState } from './components/context/PickerContext'
import { Preview } from './components/footer/Preview'
import { Header } from './components/header/Header'
import PickerMain from './components/main/PickerMain'
import { PickerConfig } from './config/config'
import { compareConfig } from './config/compareConfig'
import { useAllowExpandReactions, useOpenConfig } from './config/useConfig'

function EmojiPicker(props: PickerConfig) {
  return (
    <ElementRefContextProvider>
      <PickerStyleTag />
      <PickerConfigProvider {...props}>
        <ContentControl />
      </PickerConfigProvider>
    </ElementRefContextProvider>
  )
}

function ContentControl() {
  const [reactionsDefaultOpen] = useReactionsModeState()
  const allowExpandReactions = useAllowExpandReactions()

  const [renderAll, setRenderAll] = useState(!reactionsDefaultOpen)
  const isOpen = useOpenConfig()

  useEffect(() => {
    if (reactionsDefaultOpen && !allowExpandReactions) {
      return
    }

    if (!renderAll) {
      setRenderAll(true)
    }
  }, [renderAll, allowExpandReactions, reactionsDefaultOpen])

  if (!isOpen) {
    return null
  }

  return (
    <PickerMain>
      <Reactions />
      <ExpandedPickerContent renderAll={renderAll} />
    </PickerMain>
  )
}

function ExpandedPickerContent({ renderAll }: { renderAll: boolean }) {
  if (!renderAll) {
    return null
  }

  return (
    <>
      <Header />
      <Body />
      <Preview />
    </>
  )
}

// eslint-disable-next-line complexity
export default memo(EmojiPicker, compareConfig)
